import { useState } from "react";
import { Share2, Check, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/useToast";
import { track } from "@/lib/track";
import { cn } from "@/lib/utils";

const SHARE_TEXT =
  "Learn Bitcoin Cash by doing — interactive lessons, XP, badges, and a certificate. Check out BCH School!";

export function ShareSiteButton({ className }: { className?: string }) {
  const { toast } = useToast();
  const [copied, setCopied] = useState(false);

  async function share() {
    track("share_click");
    const url = window.location.origin;
    // Prefer the native share sheet on mobile.
    if (navigator.share) {
      try {
        await navigator.share({ title: "BCH School", text: SHARE_TEXT, url });
        return;
      } catch {
        // user cancelled or unsupported — fall through to copy
      }
    }
    try {
      await navigator.clipboard.writeText(`${SHARE_TEXT} ${url}`);
      setCopied(true);
      toast({
        title: "Link copied!",
        description: "Share BCH School anywhere you like.",
      });
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast({
        title: "Couldn't copy",
        description: "Please copy the URL from your browser bar.",
        variant: "destructive",
      });
    }
  }

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={share}
      className={cn(className)}
    >
      {copied ? (
        <Check className="mr-1.5 h-4 w-4" />
      ) : navigator.share ? (
        <Share2 className="mr-1.5 h-4 w-4" />
      ) : (
        <Copy className="mr-1.5 h-4 w-4" />
      )}
      {copied ? "Copied!" : "Share BCH School"}
    </Button>
  );
}
